import React, { useState } from 'react';
import './index.css';

const API_BASE = process.env.REACT_APP_API_URL;

const CustomerForm = ({ onSuccess, onError, logout, notify }) => {
    const [clientData, setClientData] = useState({
        name: '',
        description: '',
        notice: '',
        job_number_letter: '',
        logo: null
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        setClientData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleFileChange = (event) => {
        const { name, files } = event.target;
        setClientData(prevData => ({
            ...prevData,
            [name]: files[0]
        }));
    };

    const addClient = () => {
        const token = localStorage.getItem('access_token');
        const headers = new Headers({
            'Authorization': `Bearer ${token}`,
        });

        const formData = new FormData();
        for (const key in clientData) {
            formData.append(key, clientData[key]);
        }

        const url = API_BASE + '/api/clients/?format=json';

        fetch(url, {
            method: 'POST',
            headers: headers,
            body: formData,
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(() => {
            setClientData({
                name: '',
                description: '',
                notice: '',
                job_number_letter: '',
                logo: null
            });
            if (onSuccess) onSuccess();
        })
        .catch(error => {
            let errorMessage = '';
            Object.keys(error).forEach(key => {
                if (Array.isArray(error[key]) && error[key].length > 0) {
                    errorMessage += `${key}: ${error[key][0]}\n`;
                }
            });

            if (error.code === 'token_not_valid') {
                logout();
            }

            notify(`Error adding client: ${errorMessage}`);
            if (onError) onError(error);
            console.error('Error adding client:', error);
        });
    };

    return (
        <section className="customer-form-card">
            <div className="customer-form-card__header">
                <div>
                    <p className="customer-form-card__eyebrow">Customer Setup</p>
                    <h2>New customer type</h2>
                </div>
                <span className="customer-form-card__badge">Admin</span>
            </div>

            <div className="customer-form-grid">
            <div className="formGroup customer-form-grid__full">
                <label htmlFor="name" className="label">Customer Name</label>
                <input
                    type="text"
                    id="name"
                    name="name"
                    value={clientData.name}
                    onChange={handleChange}
                    className="input"
                />
            </div>

            <div className="formGroup">
                <label htmlFor="job_number_letter" className="label">Job Number Letter</label>
                <input
                    type="text"
                    id="job_number_letter"
                    name="job_number_letter"
                    value={clientData.job_number_letter}
                    onChange={handleChange}
                    className="input customer-form-code"
                    maxLength="6"
                />
            </div>

            <div className="formGroup">
                <label htmlFor="logo" className="label">Logo</label>
                <input
                    type="file"
                    id="logo"
                    name="logo"
                    onChange={handleFileChange}
                    className="input customer-form-file"
                />
            </div>

            <div className="formGroup customer-form-grid__full">
                <label htmlFor="description" className="label">Customer Description</label>
                <textarea
                    id="description"
                    name="description"
                    value={clientData.description}
                    onChange={handleChange}
                    className="input customer-form-textarea"
                />
            </div>

            <div className="formGroup customer-form-grid__full">
                <label htmlFor="notice" className="label">Customer Notice</label>
                <textarea
                    id="notice"
                    name="notice"
                    value={clientData.notice}
                    onChange={handleChange}
                    className="input customer-form-textarea"
                />
            </div>
            </div>

            <div className="customer-form-footer">
                <p className="customer-form-footer__hint">
                    The job number letter becomes the shorthand prefix your team sees during scheduling.
                </p>
                <button type="button" onClick={addClient} className="button customer-form-submit">
                    Save Customer
                </button>
            </div>
        </section>
    );
}

export default CustomerForm;
